<script setup lang="ts">
import { ref } from 'vue'
import { BlueMarble } from '@/layouts'
import { Button } from '@/components/ui/button'
import SignInPage from '@/pages/Auth/SignInPage.vue'
import SignUpPage from '@/pages/Auth/SignUpPage.vue'

const isSignUp = ref(false)
</script>

<template>
  <BlueMarble>
    <div class="w-full min-h-[400px] flex flex-col bg-card text-foreground rounded-2xl border border-border shadow-[0_40px_100px_-15px_rgba(0,0,0,0.9),0_0_120px_-20px_rgba(255,255,255,0.15)] px-5 py-5 overflow-hidden" style="perspective: 800px;">
      <div class="flex-1">
        <Transition name="card-flip" mode="out-in">
          <SignUpPage v-if="isSignUp" key="signup" local-toggle @toggle-to-signin="isSignUp = false" />
          <SignInPage v-else key="signin" heading="Welcome to Earth" subheading="Sign in to continue" local-toggle @toggle-to-signup="isSignUp = true" />
        </Transition>
      </div>
      <div class="text-sm text-center mt-4">
        <template v-if="isSignUp">
          <span class="text-gray-600">Already have an account? </span>
          <Button variant="link" class="p-0 h-auto" @click="isSignUp = false">Sign in</Button>
        </template>
        <template v-else>
          <span class="text-gray-600">Don't have an account? </span>
          <Button variant="link" class="p-0 h-auto" @click="isSignUp = true">Sign up</Button>
        </template>
      </div>
    </div>
  </BlueMarble>
</template>

<style scoped>
.card-flip-leave-active {
  animation: flipOut 0.25s ease-in forwards;
}
.card-flip-enter-active {
  animation: flipIn 0.25s ease-out forwards;
}
@keyframes flipOut {
  from { transform: rotateY(0deg); opacity: 1; }
  to   { transform: rotateY(90deg); opacity: 0; }
}
@keyframes flipIn {
  from { transform: rotateY(-90deg); opacity: 0; }
  to   { transform: rotateY(0deg); opacity: 1; }
}
</style>
